import React, { useState } from 'react';
import { Props } from './props';
import { Container, Horario, Parceiro, Status } from './styles';
import iconcoleta from '../../../../../../assets/img/coleta.svg';
import iconentrega from '../../../../../../assets/img/entrega.svg';
import ModalDetalhes from './Modal/index';
import { getDetalheAgendamento } from '../../services/index';
import Swal from 'sweetalert2';
import { AgendamentoServices } from '../../../../../agendamentos/submodules/agendamentos/services/AgendamentoServices';
import { ApplicationState } from '../../../../../../store';
import { useSelector } from 'react-redux';

const CardMobile: React.FC<Props> = ({ consultaAgendamentos }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [detalhesAgendamento, setdetalhedoAgendamento] = useState<any>({});
  const [pedidosOrdemCarga, setPedidosOrdemCarga] = useState([]);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);

  const showModal = async (item: any) => {
    setIsModalVisible(true);
    setConfirmLoading(true);

    try {
      await getDetalheAgendamento
        .getDetalheAgendamento(item.codCentroDistribuicao, item.codAgendamento)
        .then((response: any) => {
          setdetalhedoAgendamento(response?.data.agendamento);
          AgendamentoServices.getPedidosOrdemCarga(
            item.codOrdemCarga,
            item.codCentroDistribuicao,
            inscricaoAtiva
          ).then((res) => {
            setPedidosOrdemCarga(res?.data.pedidos);
            setConfirmLoading(false);
          });
        });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar os detalhes deste agendamento.',
        html: '',
        icon: 'warning',
        showConfirmButton: true,
        // timer: 1500,
      });
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <>
      {consultaAgendamentos.map((item: any) => (
        <Container
          onClick={() => showModal(item)}
          key={item.id}
          className="themeTableConsultaAgendamento"
        >
          <Horario>
            {item?.dhAgendamento.split(' ')[1] + ' - ' + item?.fimPrevisto.split(' ')[1]}
            <img
              src={item?.tipoWms === 'EXP' ? iconcoleta : iconentrega}
              alt="icone do agendamento"
              style={{ marginLeft: '5px' }}
              className="svg"
            />
          </Horario>
          <Parceiro>{item?.cliente}</Parceiro>
          <Status>
            Status:{' '}
            <span style={{ color: item?.status === 'AGE' ? '#1890ff ' : '#B45309' }}>
              {item?.status === 'AGE' ? 'Agendado' : 'Expedido'}
            </span>
          </Status>
        </Container>
      ))}

      <ModalDetalhes
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        confirmLoading={confirmLoading}
        detalhesAgendamento={detalhesAgendamento}
        pedidosOrdemCarga={pedidosOrdemCarga}
      />
    </>
  );
};

export default CardMobile;
